import * as React from 'react';
import styled from 'styled-components';
import DisplayText from '@sdk/components/ui/DisplayText';
import { DisplayTextProps } from '@sdk/components/ui/DisplayTextStyle';

const InlineCodeContainer = styled.span`
  border: 1px solid;
  color: red;
  background-color: ${({ theme }): string => theme.colors.bodyBg};
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 4px;
  border-color: ${({ theme }): string => theme.colors.separatorOnGray};
`;

type LeafTextProps = {
  highlight: boolean;
};

const LeafText = styled(DisplayText)<LeafTextProps & DisplayTextProps>`
  background: ${(props): string =>
    props.highlight ? props.theme.colors.hoverBrand : 'transparent'};
`;

type Props = {
  attributes: Record<string, unknown>;
  leaf: {
    bold?: boolean;
    italic?: boolean;
    underline?: boolean;
    code?: boolean;
    strikethrough?: boolean;
    highlight?: boolean;
  };
};

const Leaf: React.FC<React.PropsWithChildren<Props>> = ({ children, attributes, leaf }) => {
  const { bold, italic, underline, strikethrough, code, highlight } = leaf;

  const textProps = {
    bold: bold ?? false,
    italic: italic ?? false,
    underline: underline ?? false,
    textDecoration: '',
  };

  if (strikethrough) {
    textProps.textDecoration = underline ? 'line-through underline' : 'line-through';
  }

  if (code) {
    children = (
      <InlineCodeContainer>
        <span {...attributes}>
          <DisplayText {...textProps} fontSize={14}>
            {children}
          </DisplayText>
        </span>
      </InlineCodeContainer>
    );
  }

  return (
    <LeafText {...textProps} fontSize={14} highlight={highlight}>
      <span {...attributes}>{children}</span>
    </LeafText>
  );
};

export default Leaf;
